import { useStyles } from "./styles";
import { Grid } from '@mui/material';
// import { Box } from "@mui/material";

const RightPanel = () => {
  const rightPanel: string[] = [
    // "/rightpanel/3.png",
    // "/rightpanel/4.png",
    // "/rightpanel/5.png",
  ];
  const classes = useStyles();
  return (
    // <Box className={classes.rightPanel}>
    <Grid item xs={12} sm={2}>
      {rightPanel.map((item, index) => {
        return (
          <img
            key={index}
            src={item}
            alt=""
            className={classes.leftPanelImages}
          />
        );
      })}
    </Grid>
  );
};

export { RightPanel };
